module.exports = __webpack_public_path__ + "img/avatar0.76f7d5ab.png";